import React, { useEffect, useState } from 'react';
import './index.scss';
import { getGameStoreStatsInfo, getGameStoreTimelineInfo } from '@op/services';
import { canRequest } from '../utils';
import { dealwithTimelineList, defaultTimelineData } from '@op/pages/gamestore/utils';
import MobileGameStore from '../GameStore/MobileGameStore';
import Abnormal from '@home/components/Abnormal';


interface IProps {
  // 筛选器
  filter: any;
  // 竞品浮窗是否延时请求
  isDelay?: boolean;
  isFullscreen?: boolean;
  config?: { 
    // 竞品浮窗是否延时请求
    isDelay: boolean;
    className: string;
    style: React.CSSProperties;
  }; 
};

export default function OpinionsGameStoreMobile(props: IProps) {

  const {filter} = props || {};
  const [loading, setLoading] = useState(false);
  const [trendLoading, setTrendLoading] = useState(false);
  const [empty, setEmpty] = useState(true);

  const [mobileGameStoreData, setMobileGameStoreData] = useState({});
  const [mobileTrendData, setMobileTrendData] = useState({});

  // 获取手游数据
  function getMobileGameStoreData() {
  // 接口传参
    const params = {
      ...(filter || {}),
      channel: ["app store", "google play"],
      types: ["lifetime", "selected"],
      only_date_filter: true,
    };
    setLoading(true);
    getGameStoreStatsInfo(params)
      .then((data: any) => {
        // 数据格式化成舆情组件需要的格式
        const formattedData: Record<string, any> = {};
    
        data.forEach((item: any) => {
          const { type, new_list } = item;
          if (!Array.isArray(new_list)) return;
    
          new_list.forEach((entry: any) => {
            const channel = entry.channel?.toLowerCase();
            if (!channel) return;
    
            if (!formattedData[channel]) {
              formattedData[channel] = {
                selected: [],
                lifetime: [],
              };
            }
    
            formattedData[channel][type] = entry;
          });
        });
    
        setMobileGameStoreData(formattedData);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // 获取手游趋势图数据
  function getMobileTrendsData () {
    setTrendLoading(true);
    // setUserScoreTrendsApiError(false);
    getGameStoreTimelineInfo({
      ...filter,
      channel: ["app store", "google play"],
      types: ['lifetime', 'selected'],
    })
      .then((data: any) => {
        const globalTrendsTimeline = JSON.parse(JSON.stringify(defaultTimelineData()));
        const { date_type } = filter;
        const { timeline_list, timeline_of_end_time, timeline_of_start_time } =
            data || {};
        const globalTimelineMap: any = {
          'google play': { selected: [], lifetime: [] },
          'app store': { selected: [], lifetime: [] },
          taptap: { selected: [], lifetime: [] },
        };

        timeline_list?.map(({ type, list }: any) => {
          list
            ?.filter((item: { region: string; }) => item.region !== 'global')
            ?.forEach((item: { region: any; channel: any; }) => {
              if (item.region === '') {
                const newKey = item.channel;
                globalTimelineMap[newKey]?.[type]?.push(item);
              }
            });
        });
  
        for (const key in globalTimelineMap) {
          const { selected, lifetime } = globalTimelineMap[key] || {
            selected: [],
            lifetime: [],
          };
          globalTrendsTimeline[key] = dealwithTimelineList(
            [
              { type: 'selected', list: selected },
              { type: 'lifetime', list: lifetime },
            ],
            timeline_of_start_time,
            timeline_of_end_time,
            date_type,
          );
        }
        setMobileTrendData(globalTrendsTimeline);
      })
      .finally(() => setTrendLoading(false));
  };

  useEffect(() => {
    if (canRequest(filter)) {
      getMobileGameStoreData();
      getMobileTrendsData ();
    }
  }, [filter]);

  // 判断是否无数据
  useEffect(() => {
    setEmpty(!mobileGameStoreData);

  }, [mobileGameStoreData]);

  return (
    <Abnormal classNames={"dbh-studio-opinion-game-store-mobile-abnormal"} isLoading={loading || trendLoading} isNoData={empty}
      component={
        <MobileGameStore className={"dbh-studio-opinion-game-store-mobile"}filter={filter} data={mobileGameStoreData} trendsData={mobileTrendData} />
      }
    >

    </Abnormal>
  );
}
